import {Action} from '../typescript/actionTypes';
import {ActionTypes} from '../types/actionTypes';

export function getReleaseNotes(): Action {
    return {type: ActionTypes.GET_RELEASE_NOTES_REQUESTED, payload: ''};
}
